import { useEffect, useRef } from 'react'
import { ReactComponent as Close } from '../assets/icons/close.svg'
import { ReactComponent as Dot } from '../assets/icons/status-dot.svg'

export default function ClassroomStudentModal({ close, classroomId, studentList }) {
  // useEffect(() => {
  //   getClassRoomStudentsApi(classroomId)
  // }, [classroomId])
  // const [studentList, setStudentList] = useState([])
  // const getClassRoomStudentsApi = async (classroomId) => {
  //   const getClassRoomStudentsResponse = await getClassRoomStudents({
  //     classroomId: classroomId,
  //   })

  //   if (getClassRoomStudentsResponse.error) {
  //     console.log(getClassRoomStudentsResponse)
  //     return
  //   } else {
  //     console.log(getClassRoomStudentsResponse.data)
  //     setStudentList(getClassRoomStudentsResponse.data)
  //   }
  // }

  /*************** 외부 영역 클릭 Ref **************/
  const modalRef = useRef()
  useEffect(() => {
    function handleClickOutside(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    // eslint-disable-next-line
  }, [modalRef])
  return (
    <div className='relative left-0 top-0 z-[999] flex h-full w-full items-center justify-center overflow-auto'>
      <div
        ref={modalRef}
        className='modal_xs board:modal_md tab:modal_sm tab:bottom-64 tab:w-[416px] board:w-[518px] tab:gap-20 board:gap-24 tab:pb-28 board:pb-32 tab:pr-24 board:pr-28 board:bottom-[84px] absolute bottom-[44px] left-[112px] flex w-[348px] flex-col gap-16 fill-label-default pb-20'
      >
        <div className='flex items-center justify-between'>
          <p className='tab:text-h2-semibold text-caption-semibold text-label-default'>
            수업참여자
          </p>
          <Close className='tab:h-28 tab:w-28 h-20 w-20 cursor-pointer' onClick={close} />
        </div>
        <div className='flex flex-col gap-12'>
          <div className=''>
            <div className='tab:py-8 text-caption2-regular tab:text-body3-regular flex w-full border-y-[1px] border-solid border-border-default bg-fill-alternative px-12 py-4 text-label-info'>
              <p className='tab:min-w-[112px] board:min-w-[140px] min-w-[100px] shrink-0'>
                접속상태
              </p>
              <p className='tab:min-w-[105px] board:min-w-[140px] min-w-[83px] shrink-0'>반번호</p>
              <p className='tab:min-w-[105px] board:min-w-[140px] min-w-[83px] shrink-0'>이름</p>
            </div>
            <div className='tab-scroll-bar board:h-[360px] h-[240px] w-full overflow-y-auto pr-4'>
              {studentList?.length === 0 ? (
                <div className='flex h-full w-full items-center justify-center'>
                  <p className='text-center text-body2-long-medium text-label-info'>
                    검색 결과가 없습니다.
                    <br />
                    필터를 다시 설정하거나 다른 검색어를 입력해보세요.
                  </p>
                </div>
              ) : (
                studentList?.map((studentItem, studentIndex) => (
                  <div
                    key={studentIndex}
                    className='text-caption2-regular tab:py-10 tab:px-12 tab:text-body2-regular board:p-12 flex items-center border-b-[1px] border-solid border-border-default px-12 py-10 text-label-sub'
                  >
                    <div className='tab:min-w-[112px] board:min-w-[140px] min-w-100'>
                      <div
                        // className='
                        className={`tab:gap-8 tab:py-4 tab:pl-12 tab:pr-8 flex w-max items-center gap-4 rounded-[120px] py-2 pl-8 pr-6 ${studentItem.isActive ? 'bg-background-secondary fill-border-active text-border-active' : 'bg-background-alternative fill-label-info text-label-info'}`}
                      >
                        <Dot className='tab:w-full tab:h-full h-4 w-4' />
                        <p
                          className='text-caption2-medium tab:text-body2-medium tab:min-w-42'
                          // className={`${studentItem.isActive?''}`}
                        >
                          {studentItem.isActive ? `접속` : `미접속`}
                        </p>
                      </div>
                    </div>
                    <p className='tab:min-w-[105px] board:min-w-[140px] min-w-[83px] shrink-0'>
                      {`${studentItem.grade}학년 ${studentItem.classNumber}반 ${studentItem.studentNumber}번`}
                    </p>
                    <p className='tab:min-w-[105px] board:min-w-[140px] min-w-[83px] shrink-0'>
                      {studentItem.name}
                    </p>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
